import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useTeamRolesSectionStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: designTokens.spacing[3],
  },
  heading: {
    fontSize: "16px",
    fontWeight: "700",
    color: projectIqTokens.ink,
    margin: "0",
    fontFamily: projectIqTokens.fontFamily,
  },
  headingGroup: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[3],
  },
  learnMoreLink: {
    fontSize: designTokens.fontSize.xs,
    color: projectIqTokens.teal,
    ":hover": {
      color: projectIqTokens.tealInk,
      textDecoration: "underline",
    },
  },
  cardGrid: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[3],
  },
  skeletonLinksContainer: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[1],
  },
  skeletonLink: {
    height: "14px",
    borderRadius: designTokens.borderRadius.sm,
  },
});
